import RiepilogoPrestazioniAggiuntive from "../";

const routes = [
  { name: "RiepilogoPrestazioniAggiuntive", path: "/riepilogoprestazioniaggiuntive", component: RiepilogoPrestazioniAggiuntive.RiepilogoPrestazioniAggiuntive, meta: { title: "Riepilogo Prestazioni Aggiuntive" } },

 
];
export default routes;
